// Copyright (c) 2020 by Audere
//
// Use of this source code is governed by an LGPL-3.0 license that
// can be found in the LICENSE file distributed with this file.

import {
  Question,
  QuestionValidator,
  isDateQuestion,
} from "../QuestionnaireTypes";
import { isValid, parseISO } from "date-fns";

import { isAfter } from "date-fns";

export const questionnaireDateValidator: QuestionValidator = (
  text: string | null,
  questions,
  currentQuestion: Question
): string | undefined => {
  if (!isDateQuestion(currentQuestion)) {
    throw new Error("dateValidator can only be used on a DateQuestion");
  }

  if (!text && text !== "") {
    return;
  }

  const date = parseISO(text);
  if (!isValid(date)) {
    return "Invalid Date";
  }

  if (currentQuestion.minDate && isAfter(currentQuestion.minDate, date)) {
    return `Date must be after ${currentQuestion.minDate.toLocaleDateString()}`;
  }
  if (currentQuestion.maxDate && isAfter(date, currentQuestion.maxDate)) {
    return `Date must be before ${currentQuestion.maxDate.toLocaleDateString()}`;
  }
  return;
};
